import { css } from "lit";

export const style = css`
	:host {
		border: 1px solid var(--og-border-color);
		border-radius: var(--og-base-radius);
		display: flex;
		flex-direction: column;
		height: 100%;
		background: var(--og-background-color);
		position: relative; /* anchors the toggles popover */
	}

	.input {
		outline: none;
		background: transparent;
		color: var(--og-text-color);
		border: none;
		flex: 1;
		padding: 5px;
		overflow-y: auto;
		white-space: pre-wrap;
		resize: none;
	}

	.controls {
		padding: 5px 10px;
		flex: 0 0 50px;
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 10px;
	}

	.context-toggle {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		user-select: none;
		color: var(--og-text-color);
		font-size: 12px;
	}

	.context-toggle og-switch {
		height: 18px;
	}

	/* collapsed switches (narrow input): one button + a popover above the controls */
	.btn-toggles {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		color: var(--og-text-color);
		cursor: pointer;
	}

	.btn-toggles:hover, .btn-toggles.open {
		background-color: var(--og-colortype-gray-background-color);
	}

	.btn-toggles .badge {
		position: absolute;
		top: 0;
		right: 0;
		min-width: 14px;
		height: 14px;
		padding: 0 3px;
		border-radius: 7px;
		background-color: var(--og-accent-color);
		color: white;
		font-size: 10px;
		line-height: 14px;
		text-align: center;
	}

	.toggles-popover {
		position: absolute;
		left: 10px;
		bottom: 50px;
		z-index: 10;
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 10px 12px;
		border: 1px solid var(--og-border-color);
		border-radius: var(--og-base-radius);
		background: var(--og-background-color);
		box-shadow: var(--og-base-shadow);
	}

	.btn-send, .btn-stop {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background-color: var(--og-accent-color);
		color: white;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
		position: relative;
	}

	.btn-send>og-icon {
		position: absolute;
		top: 7px;
		left: 6px;
	}

	.btn-stop>og-icon {
		position: absolute;
		top: 7px;
		left: 5px;
	}

	.btn-send.disabled {
		background-color: var(--og-colortype-gray-background-color);
		cursor: not-allowed;
	}

	.btn-stop {
		background-color: var(--og-colortype-red-background-color, #d9534f);
	}

	.btn-attach {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		color: var(--og-text-color);
		cursor: pointer;
	}

	.btn-attach:hover {
		background-color: var(--og-colortype-gray-background-color);
	}

	.attachments {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 5px 10px 0;
	}

	.attachment {
		position: relative;
		width: 56px;
		height: 56px;
		border: 1px solid var(--og-border-color);
		border-radius: var(--og-base-radius);
		overflow: hidden;
	}

	.attachment img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	/* a text file: icon + name chip instead of a thumbnail */
	.attachment-file {
		width: auto;
		max-width: 260px;
		height: 32px;
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 0 28px 0 8px;
		font-size: 0.85em;
	}

	.attachment-name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* a spreadsheet being converted: spinner + name + status, no remove button */
	.attachment-converting {
		padding-right: 8px;
	}

	.attachment-status {
		color: var(--og-color-secondary, gray);
		white-space: nowrap;
	}

	.attachment-file .attachment-remove {
		top: 8px;
		right: 6px;
	}

	.attachment-remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 16px;
		height: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.55);
		color: white;
		font-size: 10px;
		cursor: pointer;
	}
`
